import React, { createContext, useContext } from 'react';
import useLocalStorage from '../hooks/useLocalStorage';

interface AdContextType {
  adMinimized: boolean;
  setAdMinimized: (minimized: boolean) => void;
}

const AdContext = createContext<AdContextType | undefined>(undefined);

export const AdProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Use our custom hook for localStorage instead of manual implementation
  const [adMinimized, setAdMinimized] = useLocalStorage<boolean>('adMinimizedState', false);
  
  return (
    <AdContext.Provider value={{ adMinimized, setAdMinimized }}>
      {children}
    </AdContext.Provider>
  );
};

// Custom hook to use the ad context
export const useAdState = (): AdContextType => {
  const context = useContext(AdContext);
  if (context === undefined) {
    throw new Error('useAdState must be used within an AdProvider');
  }
  return context;
};